import { SecurityScanner } from "@/pages/security-scanner";

export function StudioSecurityPage() {
  return <SecurityScanner />;
}
